const StateManager = (function(window, $) {

    // When all assets have been loaded (eg. css, scripts, images)
    let resourcesLoaded = new Promise(function (resolve) {
        $(window).one('load', resolve);
    });

    // When stylesheets have been loaded (with critical css support)
    let stylesheetsLoaded = new Promise(function (resolve) {
        let preloadStylesheets = $('link[rel="preload"][data-rocket-async="style"]').toArray();

        // Not found, so it's already captured by window load event
        if (preloadStylesheets.length === 0) {
            resolve();
            return;
        }

        let promises = preloadStylesheets.map(function (link) {
            return new Promise(function (resolve) {
                $(link).one('load', resolve);
            });
        });

        // Wait until all are ready
        Promise.all(promises).then(resolve);
    });

    // Detect if inline critical css is removed. There are some differences between critical and original css which can cause misalignment
    let criticalCssRemoved = new Promise(function (resolve) {
        let tries = 0;
        let maxTries = 10;
        let check = function () {
            let inlineStyle = $('style#rocket-critical-css');
            if (inlineStyle.length === 0) {
                resolve(); // Page render is final
            } else if (tries === maxTries) {
                resolve(); // It has been enough
            } else {
                tries++;
                setTimeout(check, 200); // Try again
            }
        };

        // No inline critical css detected
        if ($('style#rocket-critical-css').length === 0) {
            resolve();
            return;
        }

        // Wait until ready
        setTimeout(check, 200);
    });

    return {
        resourcesLoaded: resourcesLoaded,
        stylesheetsLoaded: stylesheetsLoaded,
        criticalCssRemoved: criticalCssRemoved
    };

}(window, jQuery));

export {StateManager};
